import React, { useEffect, useState } from 'react';
import './inventaire.css';
import Filtres from './Filtres';
import ModalItemDescription from '../../modal/ModalItemDescription';
import { moneyMaker } from '../../../utils';
import { ReactComponent as Taria_Gold } from '../../../svg/Taria_Gold.svg';
import { ReactComponent as Taria_Silver } from '../../../svg/Taria_Silver.svg';
import { ReactComponent as Taria_Bronze } from '../../../svg/Taria_Bronze.svg';

const PageInventaire = ({ items, category , tags,token }) => {
  
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [shownItems, setShownItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpenDesc, setIsModalOpenDesc] = useState(false);
  const [tagSelected, setTagSelected] = useState([]);

  const filterItems = () => {
    let result = items;
    if (tagSelected.length > 0) {
      result = result.filter(item =>
        tagSelected.some(selectedTag => item.tags.includes(selectedTag.nom))
      );
    } 
    // else if (tag) {
    //   result = result.filter(item => item.tags.includes(tag));
    // }
    setFilteredItems(result);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClick = (e) => {
    setSelectedItem(e);
    setIsModalOpenDesc(!isModalOpenDesc);
    };


  useEffect(() => {
    filterItems();
  }, [category, items, tagSelected]);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setShownItems(filteredItems);
    } else {
      const searchedItems = filteredItems.filter(item =>
        item.item_nom.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setShownItems(searchedItems);
    }
  }, [searchQuery, filteredItems]);

  return (
    <div className="table_wrap_equipement">
      <div className='search_wrapper_equipement'>
        <input
          type='text'
          className='search_bar_equipement'
          placeholder='Recherche...'
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>
      <div className='search_wrapper_equipement'>
        {/* <button
          className='filtre_button_equipement'
          onClick={() => setModalOpen(!modalOpen)}
        >
          Filtres
        </button>
        <Filtres
          isOpen={modalOpen}
          setOpen={setModalOpen}
          setTags={setTagSelected}
          tags={tags}
        /> */}
      </div>

      <div className='search_wrapper_equipement'>
        <table className="table_equipement">
          <tbody>
            {shownItems.map(item => (
              <tr
                key={item.idItem}
                className="table_row_equipement"
                onClick={() => handleClick(item)}
              >
                <td>
                  <div className='margin_1em'><span><strong>{item.item_nom}</strong></span></div>
                </td>
                <td className='info_equipement'>
                  <div className='margin_0_2em '>Quantité: {item.quantite}</div>
                  <div className='margin_0_2em flex align_center'>Valeur: <div className="modal_moneys flex">
                    <span>{moneyMaker(item.valeur).or}</span>
                    <Taria_Gold className="modal_money"></Taria_Gold>
                    <span>{moneyMaker(item.valeur).argent}</span>
                    <Taria_Silver className="modal_money"></Taria_Silver>
                    <span>{moneyMaker(item.valeur).bronze}</span>
                    <Taria_Bronze className="modal_money"></Taria_Bronze>
                  </div></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {selectedItem &&
        <ModalItemDescription
          isOpen={isModalOpenDesc}
          setOpen={setIsModalOpenDesc}
          item={selectedItem}
          token={token}
        />
      }

    </div>
  );
};

export default PageInventaire;
